import { Countries, StoreState } from 'app/state/types'

interface State extends StoreState {
    countries?: Countries | undefined
}

type MultipleLanguageCountry = {
    [countryCode: string]: string[]
}

export default function getMultipleLanguageCountries(state: State) {
    const { countries } = state

    if (countries) {
        const countryISOCodes: MultipleLanguageCountry = Object.keys(countries).reduce((acc, currentISOCode) => {
            const currentCountryObject = countries[currentISOCode]
            const currentCountryLangs = Object.keys(currentCountryObject.languages)

            if (currentCountryLangs.length > 1) {
                acc[currentISOCode] = currentCountryLangs
            }

            return acc
        }, {})

        return { multipleLanguageCountries: countryISOCodes }
    } else {
        return {}
    }
}
